import enLocale from 'element-ui/lib/locale/lang/en'  // 饿了么

import { bloomTestEn } from './bloom-test'              // bloom-test
import { loginOrResEn } from './loginOrRes'
import { homeEn } from './home/'
import { headerEn } from './header/'
import { authenticationEn } from './authentication'
import { battleEn } from './battle/index'
import { proctorEn } from './proctor/proctor'
import { mobileEn } from './proctor/mobile'
import { faceTipBoxEn } from './proctor/faceTipBox'
import { sqEn } from './sq'
import { waitingExaminationEn } from './proctor/waitingExamination'
import { equipmentCheckEn } from './proctor/equipmentCheck'
import { automaticResponseEn } from './proctor/automaticResponse'
import { flowHomeEN } from './flow/home'
import { flowAcademicReportEN } from './flow/academicReport'
import { flowActiveEN } from './flow/active'
import { flowAdmissionTicketEN } from './flow/admissionTicket'
import { flowCertificateEN } from './flow/certificate'
import { flowComplainEN } from './flow/complain'
import { flowConsultEN } from './flow/consult'
import { flowCouponEN } from './flow/coupon'
import { flowDiscoverEN } from './flow/discover'
import { flowFollowUsEN } from './flow/followUs'
import { flowGradeReportEN } from './flow/gradeReport'
import { flowGroupEN } from './flow/group'
import { flowLoginEN } from './flow/login'
import { flowMessageEN } from './flow/message'
import { flowOrderEN } from './flow/order'
import { flowPayTheFeesEN } from './flow/payTheFees'
import { flowPersonalDataEN } from './flow/personalData'
import { flowReviewEN } from './flow/review'
import { flowSignUpEN } from './flow/signUp'
import { flowTaskEN } from './flow/task'
import { flowTeamUpEN } from './flow/teamUp'
import { flowImageEN } from './flow/image'
import { questionnaireEn } from './questionnaire'
import { workOrderEn } from './workOrder'
import { customerServiceEN } from './flow/customerService'
import { flowTeamHallEN } from './flow/teamFormationHall'
import { aiContentEN } from './flow/aiContent'
import { aiStudyBuddyEn } from './aiStudyBuddy'
import { flowSurveyEN } from './flow/survey'

const en = {
  ...flowImageEN,
  ...flowGroupEN,
  ...flowTeamUpEN,
  ...flowTaskEN,
  ...flowSignUpEN,
  ...flowPersonalDataEN,
  ...flowReviewEN,
  ...flowPayTheFeesEN,
  ...flowMessageEN,
  ...flowOrderEN,
  ...flowLoginEN,
  ...flowGradeReportEN,
  ...flowFollowUsEN,
  ...flowDiscoverEN,
  ...flowCouponEN,
  ...flowConsultEN,
  ...flowComplainEN,
  ...flowAdmissionTicketEN,
  ...flowCertificateEN,
  ...flowActiveEN,
  ...bloomTestEn,
  ...loginOrResEn,
  ...homeEn,
  ...headerEn,
  ...enLocale,
  ...authenticationEn,
  ...battleEn,
  ...proctorEn,
  ...mobileEn,
  ...faceTipBoxEn,
  ...sqEn,
  ...waitingExaminationEn,
  ...equipmentCheckEn,
  ...automaticResponseEn,
  ...flowHomeEN,
  ...flowAcademicReportEN,
  ...questionnaireEn,
  ...workOrderEn,
  ...customerServiceEN,
  ...flowTeamHallEN,
  ...aiContentEN,
  ...aiStudyBuddyEn,
  ...flowSurveyEN
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js